import { FullPageModal } from '#/components/Modal/FullPageModal';
import { StatusTitle } from '#/components/Status/Status.styled';
import { noop } from '#/service/utils';
import { tb } from '#/store/translation/translation.store';

import { Payment } from '../Payment/Payment';
import {
  ChangeProductAddPaymentMethodProps,
  useChangeProductAddPaymentMethod,
} from './ChangeProductAddPaymentMethod.hook';

export const ChangeProductAddPaymentMethod = (
  props: ChangeProductAddPaymentMethodProps
) => {
  const {
    shouldRender,
    hasOwnUi,
    paymentMethods,
    handlePaymentDetailsSuccess,
    handlePaymentDetailsFailure,
    handleAddPaymentDetails,
  } = useChangeProductAddPaymentMethod(props);

  if (!shouldRender) {
    return null;
  }

  return (
    <FullPageModal applyDefaultGradient={false}>
      <FullPageModal.CenteredContent>
        <StatusTitle>{tb('iap.setUpYourPayment')}</StatusTitle>
        <Payment
          buyButtonText="web.iap.preauthorization.button"
          disclaimerText="web.iap.disclaimer"
          hasOwnUi={hasOwnUi}
          isDisabled={false}
          isPaymentDetailsRequired={true}
          onFailure={handlePaymentDetailsFailure}
          onPurchase={handleAddPaymentDetails}
          onSuccess={handlePaymentDetailsSuccess}
          paymentMethods={paymentMethods}
          setIsDisabled={noop}
        />
      </FullPageModal.CenteredContent>
    </FullPageModal>
  );
};
